export function isTokenValid() {
  const tokenStr = localStorage.getItem("token");
  const userToken = JSON.parse(tokenStr);

  if (userToken) {
    const expire = new Date(userToken.tokenExpiration);
    const currentDate = new Date();

    if (currentDate < expire) {
      return true;
    }

    //logout();
    return false;
  }

  return false;
}

export function getTokenString() {
  const tokenString = localStorage.getItem("token");
  const userToken = JSON.parse(tokenString);

  if (userToken) {
    return `Bearer ${userToken.token}`;
  }

  return null;
}

export function getUsersName() {
  const tokenString = localStorage.getItem("user");
  const userToken = JSON.parse(tokenString);

  return userToken?.name;
}

export function isNewUser() {
  const tokenString = localStorage.getItem("user");
  const userToken = JSON.parse(tokenString);

  return userToken?.new;
}

export function getUsersRoles() {
  const tokenString = localStorage.getItem("user");
  const userToken = JSON.parse(tokenString);

  return userToken?.roles;
}

export function getUserId() {
  const tokenString = localStorage.getItem("user");
  const userToken = JSON.parse(tokenString);
  return userToken?.id;
}

export function getUsersEmail() {
  const tokenString = localStorage.getItem("user");
  const userToken = JSON.parse(tokenString);

  return userToken?.email;
}

export function getUsersWorkCenter() {
  const tokenString = localStorage.getItem("user");
  const userToken = JSON.parse(tokenString);

  return userToken?.activeCenter;
}

export function getUsersWAauth() {
  const tokenString = localStorage.getItem("user");
  const userToken = JSON.parse(tokenString);

  return userToken?.WAauth;
}

export function checkRoles(role) {
  const userRoles = getUsersRoles();

  let userRole = null;

  if (!userRoles) {
    return false;
  } else if (
    userRoles.includes("Administrator") ||
    userRoles.includes("Operations-Manager")
  ) {
    userRole = 6;
  } else if (userRoles.includes("Program-Manager")) {
    userRole = 5;
  } else if (
    userRoles.includes("Research-Engineer") ||
    userRoles.includes("Lab-Manager")
  ) {
    userRole = 4;
  } else if (userRoles.includes("Cell-Manager")) {
    userRole = 3;
  } else if (userRoles.includes("Coordinator")) {
    userRole = 2;
  } else if (userRoles.includes("User")) {
    userRole = 1;
  }

  //if user's role value is greater than or equal to role to check
  if (userRole >= role) {
    return true;
  }

  return false;
}
